<!--
    @description :
    @api-property :
    @api-event :
    @api-method :

    @author :
    @dateTime :
    @lastEditDateTime :
    @lastEditors :
-->
<template>
  <div style="display: flex; justify-content: space-between; height: 100%">
    <div style="flex: 1">
      <video-player
        oncontextmenu="return false;"
        v-if="playerOptions.sources[0].src"
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
        @timeupdate="onPlayerTimeupdate($event)"
        @pause="onPlayerPause($event)"
        @ready="playerReadied"
      ></video-player>
      <!--      <video-player-->
      <!--        v-if="playerOptions.sources[0].src"-->
      <!--        class="video-player vjs-custom-skin"-->
      <!--        ref="videoPlayer"-->
      <!--        :playsinline="true"-->
      <!--        :options="playerOptions"-->
      <!--        style="width: 100%; height: 100%"-->
      <!--      ></video-player>-->
      <!--      <el-image-->
      <!--        v-else-->
      <!--        style="width: 100%; height: 100%"-->
      <!--        :src="require('@/assets/bg.jpg')"-->
      <!--        fit="cover"-->
      <!--      ></el-image>-->
      <div
        v-else
        :style="{ backgroundImage: 'url(' + require('@/assets/bg.jpg') + ')' }"
        style="
          width: 100%;
          height: 100%;
          background-repeat: no-repeat;
          background-position: center center;
          background-size: cover;
        "
      ></div>
    </div>
    <div
      style="
        width: 400px;
        border-left: 1px solid #ccc;
        height: 100%;
        overflow-y: scroll;
      "
    >
      <div
        style="
          height: 50px;
          border-bottom: 1px solid #ccc;
          padding: 0 20px;
          display: flex;
          align-items: center;
        "
      >
        <el-page-header @back="goBack" :content="$route.query.name">
        </el-page-header>
      </div>

      <div
        style="padding: 20px; border-bottom: 1px solid #ccc"
        v-for="item in classSchedule"
        :key="item.id"
      >
        <div style="display: flex; align-items: center">
          <el-image
            style="width: 100px; height: 80px"
            :src="item.cover_url"
            fit="contain"
          ></el-image>
          <div style="margin-left: 30px">
            <p>{{ item.title }}</p>
            <!--            <p style="margin-top: 10px">{{ item.created_at | timeFilter }}</p>-->
          </div>
        </div>
        <div style="display: flex" v-if="item.content">
          <p>简介：</p>
          <p v-html="item.content"></p>
        </div>
        <div
          style="
            border: 1px solid #ccc;
            border-radius: 5px;
            padding: 20px;
            margin-top: 10px;
          "
        >
          <div
            v-for="n in item.class_schedule.directory"
            :key="n.id"
            style="margin-bottom: 10px"
          >
            <p style="margin-bottom: 10px">{{ n.describe }}</p>
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px dashed #ccc;
                border-top: 1px dashed #ccc;
                padding: 10px 0;
              "
              v-for="m in n.children"
              :key="m.id"
            >
              <div>
                <p>{{ m.describe }}</p>
                <!--                <p>{{ m.created_at | timeFilter }}</p>-->
              </div>
              <el-button type="primary" size="mini" @click="playVideo(m)"
                >播放</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "video.js/dist/video-js.css";

import { videoPlayer } from "vue-video-player";
import { trainingClassService } from "@/api";
import moment from "moment";
import Cookies from "js-cookie";
import { mapState } from "vuex";
export default {
  //组件名字
  name: "ChineseMedicineDetails",
  //组件参数
  props: {},
  //组件状态数据值
  data() {
    return {
      classId: "",
      classSchedule: [],
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "", //url地址
          },
        ],
        // poster: "../../static/images/test.jpg", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
      videoD: false,
    };
  },
  filters: {
    timeFilter(time) {
      if (time) {
        return moment(time).format("YYYY-DD-MM HH:mm");
      }
    },
  },
  //计算属性
  computed: {
    ...mapState(["user"]),
  },
  async created() {
    await this.getTrainingClass();
    await this.getClassList();
  },
  //方法
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async getTrainingClass() {
      let data = await trainingClassService.officialWebsiteTrainingClassId();
      this.classId = data.data[0];
    },
    async getClassList() {
      let data = await trainingClassService.officialWebsiteTrainingClassList({
        class_id: this.classId,
        course_type_id: this.$route.query.id,
      });
      this.classSchedule = data.data.list;
      for (let i of this.classSchedule) {
        i.cover_url = await this.getUrlSrc(i.cover_url);
      }
    },
    async getUrlSrc(url) {
      let data = await trainingClassService.officialWebsiteGetPreviewUrl({
        obj_name: url,
      });
      return data.data;
    },
    async playVideo(item) {
      this.playerOptions.sources[0].src = await this.getUrlSrc(
        item.children[0].resource_url
      );
    },
    onPlayerTimeupdate(player) {
      console.log(player);
      if (
        (player.cache_.currentTime > 30 && !this.user.info) ||
        (player.cache_.currentTime > 30 && !Cookies.get("token"))
      ) {
        if (!this.videoD) {
          this.videoD = true;
          this.$alert("查看完整视频，请联系客服：010-53672266!", "提示", {
            confirmButtonText: "我知道了",
            center: true,
          }).then(() => {});
          this.$refs.videoPlayer.player.pause();
          this.$refs.videoPlayer.player.src(this.playerOptions.sources[0].src);
        }
      }
    },
    onPlayerPause() {
      this.videoD = false;
    },
    playerReadied(player) {
      console.log("player-------", player);
    },
  },
  //监听
  watch: {},

  //局部注册的组件
  components: {
    videoPlayer,
  },
};
</script>
<style>
.vjs-custom-skin > .video-js .vjs-big-play-button {
  background-color: rgba(0, 0, 0, 0.45);
  font-size: 3.5em;
  border-radius: 50%;
  height: 2em !important;
  line-height: 2em !important;
  /*margin-top: 18vw !important;*/
  /*margin-left: 31vw !important;*/
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  margin-top: -50px !important;
  margin-left: -50px !important;
  width: 2em !important;
  outline: none;
}
.video-js .vjs-big-play-button .vjs-icon-placeholder:before {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
}

.video-js .vjs-fluid,
.video-js.vjs-16-9,
.video-js.vjs-4-3 {
  width: 100%;
  max-width: 100%;
  height: 100%;
}
.video-js.vjs-fluid {
  height: 100%;
}
</style>
